import React, { useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { Gameday } from "../models/Gameday";
import { Option, Select } from "./common/Select";
import { NoItems } from "./common/NoItems";

interface GamedayHeaderProps {
  gamedays: Gameday[];
  setCurrentGameday: (gameday: Gameday) => void;
  intitialGamedayIndex?: number;
  className?: string;
  type?: "simple" | "withArrows";
}
export function GamedayHeader({
  gamedays,
  setCurrentGameday,
  intitialGamedayIndex,
  className,
  type = "withArrows",
}: GamedayHeaderProps) {
  const [currentGamedayIndex, setCurrentGamedayIndex] = useState(
    intitialGamedayIndex ?? gamedays[0]?.index ?? 0
  );

  return (
    <React.Fragment>
      {gamedays?.length > 0 && (
        <div className="flex w-full container">
          {type !== "simple" && (
            <button
              className="text-xl inline-block align-middle"
              disabled={currentGamedayIndex === 1}
              onClick={() => {
                setCurrentGamedayIndex(currentGamedayIndex - 1);
                const gameday = gamedays.find(
                  (gameday) => gameday.index === currentGamedayIndex - 1
                );
                if (gameday) {
                  setCurrentGameday(gameday);
                }
              }}
            >
              <FiChevronLeft />
            </button>
          )}
          <Select
            className={`minimal mx-2 white max-lg:w-full ${className ?? ""}`}
            value={currentGamedayIndex.toString()}
            onChange={(e) => {
              setCurrentGamedayIndex(parseInt(e));
              const gameday = gamedays.find(
                (gameday) => gameday.index === parseInt(e)
              );
              if (gameday) {
                setCurrentGameday(gameday);
              }
            }}
          >
            {gamedays.map((gameday) => (
              <Option key={gameday.id} value={gameday.index.toString()}>
                {gameday.name}
              </Option>
            ))}
          </Select>
          {type !== "simple" && (
            <button
              className="text-xl inline-block align-middle"
              disabled={currentGamedayIndex === gamedays.length}
              onClick={() => {
                setCurrentGamedayIndex(currentGamedayIndex + 1);
                const gameday = gamedays.find(
                  (gameday) => gameday.index === currentGamedayIndex + 1
                );
                if (gameday) {
                  setCurrentGameday(gameday);
                }
              }}
            >
              <FiChevronRight />
            </button>
          )}
        </div>
      )}
      {!(gamedays?.length > 0) && <NoItems />}
    </React.Fragment>
  );
}
